import { TableConfig } from "../../models/config/TableConfig";
import { ExtractedTable } from "../../models/ExtractedTable";
import { TableStatusBubble } from "../bubbles/TableStatusBubble";
import { VisibilityToggle } from "../buttons/VisibilityToggle";
import "../../styles/tableEditing/tableNameList.css";
import { OcrWarningBubble } from "../bubbles/OcrWarningBubble";
import { InvalidBubble } from "../bubbles/InvalidBubble";

export { TableNamesList, Text as TableNameText };

type Props = {
  selected: string;
  tableConfigs: TableConfig[];
  selectedTableData?: ExtractedTable | undefined;
  onChange: (tableConfig: TableConfig) => void;
};

const TableNamesList = ({
  selected,
  tableConfigs,
  selectedTableData,
  onChange,
}: Props) => {
  return (
    <div className={"tableNamesList"}>
      {/* <span style={{ display: DEBUG ? 'normal' : 'none' }}>Last updated: {lastUpdated}</span> */}
      {tableConfigs.map((table) => (
        <VisibilityToggle
          key={table.name}
          className={"tableNameBox"}
          active={table.name === selected}
          onClick={() => onChange(table)}
        >
          <Text
            name={table.name}
            extractedTable={
              table.name === selected ? selectedTableData : undefined
            }
          />
        </VisibilityToggle>
      ))}
    </div>
  );
};

type TextProps = { name: string; extractedTable: ExtractedTable | undefined };

function Text(props: TextProps) {
  const extraction = props.extractedTable ? props.extractedTable : undefined;
  const renderExtraBubbles =
    props.extractedTable?.status === "MATCH" ||
    props.extractedTable?.status === "REUSE";
  const renderMainBubble =
    renderExtraBubbles &&
    !(
      props.extractedTable?.hasOcrWarning ||
      props.extractedTable?.hasCellInvalid
    );
  if (extraction) {
    return (
      <>
        {props.name}
        {/* Do not render TableStatusBubble when status is MATCH and table.hasXXXzzzz */}
        {renderMainBubble && <TableStatusBubble status={extraction.status} />}
        {renderExtraBubbles && props.extractedTable?.hasOcrWarning && (
          <OcrWarningBubble />
        )}
        {renderExtraBubbles && props.extractedTable?.hasCellInvalid && (
          <InvalidBubble />
        )}
      </>
    );
  }
  return <>{props.name}</>;
}
